import header from '../../components/header';
import scrollSmoother from '../../behavior/scroll-smoother';

import { gsapTimelinePromise } from '.';

export const lockBodyScroll = () => {

    scrollSmoother.getInstance().paused(true);
};

export const unlockBodyScroll = () => {

    scrollSmoother.getInstance().paused(false);
};

export const scrollBy = async (
    y,
    {
        duration = 0.4,
        onComplete = () => {},
        scroller = null,
    } = {}
) => {

    if (scroller === null) {
        scroller = window;
    }

    const timeline = gsap.timeline();

    timeline.to(
        scroller,
        {
            duration,
            scrollTo: {
                y: `+=${y}`,
            },
            onComplete,
        }
    );

    await gsapTimelinePromise(timeline);
};

export const scrollTo = async (
    $element,
    {
        accountForHeader = true,
        offset = 0,
        duration = 0.4,
        onComplete = () => {},
        alignment = 'top',
        scroller = null,
        disableHeader = false,
    } = {}
) => {

    if (disableHeader) {
        header.disable();
        header.hide();
    }

    const timeline = gsap.timeline();

    if (scroller === null) {
        scroller = window;
    }

    if (scroller !== window) {
        accountForHeader = false;
    }

    const offsetForHeader = (
        accountForHeader
            ? header.els.$header().outerHeight()
            : 0
    );

    const offsetForAlignment = (() => {

        if (alignment === 'bottom') {
            return (
                $(scroller).outerHeight()
                - $element.outerHeight()
            );
        }

        if (alignment === 'center') {
            return (
                0.5 * (
                    $(scroller).outerHeight()
                    - $element.outerHeight()
                )
            );
        }

        return 0;
    })();

    const offsetY = (
        offsetForHeader
        + offsetForAlignment
        + offset
    );

    timeline.to(
        scroller,
        {
            duration,
            scrollTo: {
                y: $element,
                offsetY,
            },
            onComplete,
        }
    );

    await gsapTimelinePromise(timeline);

    if (disableHeader) {

        setTimeout(
            () => header.enable(),
            200
        );
    }
};

